import { render } from "./InputPhoneNumber.vue?vue&type=template&id=e2db7800&scoped=true"
import script from "./InputPhoneNumber.vue?vue&type=script&lang=js"
export * from "./InputPhoneNumber.vue?vue&type=script&lang=js"

import "./InputPhoneNumber.vue?vue&type=style&index=0&id=e2db7800&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2db7800"]])

export default __exports__